import {
  ListItemButton,
  ListItemText,
  ListItemAvatar,
  Divider,
  useTheme,
  Box,
  CardMedia,
} from "@mui/material"
import { deepmerge } from "@mui/utils"

export const FeatureListItem = (props) => {
  const {
    primary = "",
    secondary = "",
    onClick = () => {},
    avatar = null,
    divider,
    primaryTypographyProps = {},
    secondaryTypographyProps = {},
    endAdornment = null,
    disableTypography,
    sx,
    ...restProps
  } = props
  const theme = useTheme()
  const styleOverrides =
    theme.components[`FeatureListItem`]?.styleOverrides || {}
  const {
    root,
    adornmentDivider,
    bottomDivider,
    adornmentWrapper,
    listItemText,
    listItemAvatar,
    listItemContent,
  } = styleOverrides

  return (
    <>
      <ListItemButton
        onClick={onClick}
        {...restProps}
        disableGutters
        sx={deepmerge(root, sx)}
      >
        <ListItemAvatar
          className="FeatureListItem-listItemAvatar"
          sx={listItemAvatar}
        >
          {avatar}
        </ListItemAvatar>
        <Box sx={listItemContent} className="FeatureListItem-listItemContent">
          <ListItemText
            primaryTypographyProps={{
              variant: "title",
              component: "h6",
              ...primaryTypographyProps,
            }}
            secondaryTypographyProps={{
              variant: "subTitle",
              component: "p",
              ...secondaryTypographyProps,
            }}
            sx={listItemText}
            primary={primary}
            secondary={secondary}
            disableTypography={disableTypography}
          />
          {endAdornment && (
            <Box
              sx={adornmentWrapper}
              className="FeatureListItem-adornmentWrapper"
            >
              <Divider
                orientation="vertical"
                variant="middle"
                flexItem
                sx={adornmentDivider}
              />
              <CardMedia component="img" image={endAdornment} />
            </Box>
          )}
        </Box>
      </ListItemButton>
      {divider && (
        <Divider className="FeatureListItem-bottomDivider" sx={bottomDivider} />
      )}
    </>
  )
}
